/*
  The optional Telegram nickname on the ambassador tiers (snippets/ambassador-telegram.liquid).

  GalasTelegram.read(input) → { ok, value }: value is «@nick» or '' when the field
  is empty. Accepts «nick», «@nick» and t.me links; a nickname is 5–32 Latin
  letters, digits or «_», starting with a letter. This is a light check for typos
  and phone numbers, not proof the account exists.

  The ambassador modal, the donate and join modals and the cabinet call read()
  themselves.
*/
(function () {
  if (window.GalasTelegram) return;

  var NICK = /^[A-Za-z][A-Za-z0-9_]{4,31}$/;

  function read(input) {
    if (!input) return { ok: true, value: '' };
    var raw = input.value.trim()
      .replace(/^(?:https?:\/\/)?(?:www\.)?(?:t|telegram)\.me\//i, '')
      .replace(/^@/, '')
      .replace(/\/+$/, '');
    var ok = raw === '' || NICK.test(raw);
    input.setCustomValidity(ok ? '' : (input.getAttribute('data-error') || 'Telegram'));
    return { ok: ok, value: ok && raw ? '@' + raw : '' };
  }

  window.GalasTelegram = { read: read };

  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-amb-telegram]')) e.target.setCustomValidity('');
  });

})();
